import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';
import { IconMap } from '@divlab/divanui/icons';

import * as Meta from '@Queries/Meta';
import * as ModalWindows from '@Stores/ModalWindows';
import Link from '@UI/Link';
import styles from './Region.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface RegionProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Region: FC<RegionProps> = (props) => {
  const { className, ...restProps } = props;
  const meta = Meta.useMeta();

  const handleClickRegion = useCallback((e) => {
    e.preventDefault();

    ModalWindows.open('RegionSelector', null, { needToReplace: false });
  }, []);

  if (!meta.isSuccess) return null;

  return (
    <div {...restProps} className={cn(styles.region, className)} onClick={handleClickRegion}>
      <IconMap className={styles.icon} active />
      <Link className={styles.label} view='primary' underlined>
        {meta.data.region.name}
      </Link>
    </div>
  );
};

export default memo(Region);
